import React from "react";
import { useTranslation } from "react-i18next";

type LeaveWorkspaceModalProps = {
    workspaceName: string;
    onConfirm: () => void;
    onCancel: () => void;
};

const LeaveWorkspaceModal = ({ workspaceName, onConfirm, onCancel }: LeaveWorkspaceModalProps) => {
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div
                className="absolute inset-0 bg-dark-gray opacity-80"
                onClick={onCancel}
            ></div>
            <div className="relative z-10 flex flex-col bg-white rounded shadow w-full max-w-md mx-4">
                <div className="flex flex-row-reverse p-2">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex items-center"
                    >
                        <svg aria-hidden="true" className="w-6 h-6 text-off-black" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                        </svg>
                        <span className="sr-only">{t("Close Modal")}</span>
                    </button>
                </div>
                <div className="px-6 pb-6 lg:px-8">
                    <h2 className="text-xl text-off-black mb-3">{t("Leave Workspace?")}</h2>
                    <p className="text-secondary-gray mb-6">
                        {t("Are you sure you want to leave {{workspaceName}}? If you decide to re-join, you will have to ask the administrator to add you again.", { workspaceName })}
                    </p>
                    <div className="flex flex-row-reverse items-center">
                        <button
                            className="bg-orange hover:bg-light-orange text-white rounded py-2 px-8 ml-2 shadow"
                            type="button"
                            data-testid="AccountPage-leaveWorkspaceConfirm-button"
                            onClick={onConfirm}
                        >
                            {t("Leave Workspace")}
                        </button>
                        <button
                            className="bg-very-light-gray text-medium-gray rounded py-2 px-3 mx-2"
                            type="button"
                            data-testid="AccountPage-leaveWorkspaceCancel-button"
                            onClick={onCancel}
                        >
                            {t("Cancel")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaveWorkspaceModal;
